// Serializes data for an inline <script type="application/ld+json">.
// JSON.stringify leaves `<`, `>` and `&` as-is, so a value containing
// `</script>` would close the tag early and inject markup. Escaping them as
// \uXXXX keeps the output valid JSON (parsers read the same string back) while
// making it impossible to break out of the script element. U+2028/U+2029 are
// escaped too because they are line terminators in older JS parsers.
const UNSAFE_CHARS: Record<string, string> = {
  '<': '\\u003c',
  '>': '\\u003e',
  '&': '\\u0026',
  '\u2028': '\\u2028',
  '\u2029': '\\u2029',
}

// eslint-disable-next-line import/prefer-default-export
export const serializeJsonLd = (data: unknown): string =>
  JSON.stringify(data).replace(
    /[<>&\u2028\u2029]/g,
    (char) => UNSAFE_CHARS[char],
  )
